import {ProfileView} from "./profile.view";
import {Job, Person, Profile} from "@betrue/shared/interfaces";
import PropTypes, {InferProps} from "prop-types";
import {ProfileModalPropsTypes} from "../profile-modal/profile-modal";
import * as React from "react";
import {useEffect} from "react";
import {
  currentPerson,
  currentProfile,
  useAvatarModal,
  usePerson,
  usePrincipal,
  useProfile,
  useViewV2
} from "@betrue/front/services";
import {CircularProgress} from "@material-ui/core";

const ProfileContainerPropsTypes = {
  noJobLabel: PropTypes.string,
  firstNameLabel: PropTypes.string,
  lastNameLabel: PropTypes.string,
  priceLabel: PropTypes.string,
  ...ProfileModalPropsTypes
}

export type ProfileContainerProps = InferProps<typeof ProfileContainerPropsTypes>


export function ProfileContainer(props: ProfileContainerProps) {

  const [person, {getPersonById}] = usePerson<Person>(currentPerson)
  const [principal] = usePrincipal()
  const [viewProfile, {removeJobFromProfile, updateProfileRating, getProfileById}] = useProfile(currentProfile)
  const [viewPerson, setSubject,subjectId, subjectModel, setSubjectId, setSubjectModel] = useViewV2(currentPerson, person, getPersonById)

  const [isOpen, setOpen] = useAvatarModal()

  useEffect(() => {
    if (viewPerson?.profile?.id && !viewProfile) {
      getProfileById(viewPerson?.profile?.id)
    }
  }, [viewPerson])

  useEffect(()=> {
    if(!subjectId && ! subjectModel && principal){
      setSubjectId(principal.id)
      setSubjectModel(principal.__typename)
      setSubject(principal)
    }

  }, [principal])

  const handleJobDelete = (job: Job) => {
    removeJobFromProfile(viewProfile.id)
  }

  const handleFirstnameChanged = (v: string) => {
    //  setProfile({...profile, person: {...profile.person, firstName: v}})
  }

  const handleLastnameChanged = (v: string) => {
    // setProfile({...profile, person: {...profile.person, lastName: v}})
  }

  const handlePriceChanged = (v: number) => {
    // setProfile({...profile, price: v})
  }

  const handleRatingUpdated = (rating: Profile['rating']) => {
    updateProfileRating(rating, viewProfile.id)
  }

  const handleAvatarClick = () => {
    setOpen(true)
  }

  if (!viewProfile || !viewPerson || !principal) return (<><CircularProgress/></>)


  return (
    <ProfileView
      principal={principal}
      firstNameLabel={props.firstNameLabel}
      lastNameLabel={props.lastNameLabel}
      onFirstNameSubmit={handleFirstnameChanged}
      onLastNameSubmit={handleLastnameChanged}
      onRatingUpdated={handleRatingUpdated}
      priceLabel={props.priceLabel}
      priceSubmit={handlePriceChanged}
      onJobDelete={handleJobDelete}
      onAvatarClick={handleAvatarClick}
      submitButton={props.submitButton}
      phoneLabel={props.phoneLabel}
      dialogHeader={props.dialogHeader}
      cancelButton={props.cancelButton}
      portfolioLabel={props.portfolioLabel}
      dialogDescription={props.dialogDescription}
      emailLabel={props.emailLabel}
      availabilityLabel={props.availabilityLabel}
      noJobLabel={props.noJobLabel}
      person={viewPerson}
      profile={viewProfile}/>)
}

ProfileContainer.propTypes = ProfileContainerPropsTypes

